let stated = false
document.addEventListener('DOMContentLoaded', () => {
  const uwb = new UWB({
    uaTabletViewport: {
      init: true,
      width: 1140,
    },
    toolSmoothScroll: {
      offsetSelector: '',
    },
  });

  const uwl = new UWL('.anime');

  UWX.ScrollActionSelfElement('.anime', {
    rootMargin: '10px 20px',
    activeClass: 'uwl-run',
    timing: .5,
    once: true,
    direction: 'both',
  });

  if(767 < window.innerWidth){
    mouseoverHint();
    clickCatalog(true);
  }else{
    UWX.ScrollLock('.list-reccomend');
    clickHint();
    clickCatalog(false);
  }

  setContents();
  manageStatus();
});

const s2tConf = {
  's-01': ['t-01', 't-02', 't-03', 't-04'],
  's-02': ['t-05', 't-06', 't-07', 't-08'],
  's-03': ['t-07', 't-08', 't-09', 't-10'],
  's-04': ['t-11', 't-12', 't-13', 't-14'],
}
const t2cgConf = {
  't-01': ['c-01', 'c-02', 'c-03', 'c-04', 'c-05', 'c-06', 'g-01', 'g-02'],
  't-02': ['c-03', 'c-04', 'c-05', 'g-01', 'g-02', 'g-06'],
  't-03': ['c-03', 'c-04', 'c-05', 'c-07', 'c-08', 'c-15', 'g-01'],
  't-04': ['c-10', 'c-11', 'c-12', 'g-05'],
  't-05': ['c-06', 'c-09', 'c-11', 'g-02', 'g-03', 'g-05'],
  't-06': ['c-09', 'c-11', 'g-03', 'g-05'],
  't-07': ['g-07'],
  't-08': ['c-16', 'g-05'], //g-04
  't-09': ['c-17'],
  't-10': ['c-19', 'c-23', 'g-08'],
  't-11': ['c-07', 'c-13', 'c-18', 'c-20', 'c-22', 'g-05'],
  't-12': ['c-10', 'c-13', 'c-22', 'g-02', 'g-09'],
  't-13': ['c-13', 'g-05', 'g-07', 'g-09'],
  't-14': ['c-07', 'c-08', 'c-14', 'c-15', 'c-21', 'g-09'],
}

const setContents = () => {
  document.querySelectorAll('.list-situation li').forEach(t => {
    t.addEventListener('click', () => {
      const actived = t.classList.contains('active')

      document.querySelectorAll('.list-situation li.active').forEach(s => {
        s.classList.remove('active')
      })
      document.querySelectorAll(`.list-trouble li.suggest`).forEach(a => {
        a.classList.remove('suggest');
      });

      if(actived){
        document.querySelector('.list-situation').classList.remove('active')
        document.querySelector('.list-trouble').classList.remove('active')
        document.querySelector('.list-reccomend').classList.remove('active')
        document.querySelector('.result-default').classList.add('active')
        document.querySelectorAll('.list-trouble li.active, .list-content li.active, .list-group li.active, .list-reccomend li.active').forEach(v => {
          v.classList.remove('active')
        })
        document.querySelectorAll('.list-content li.selected, .list-group li.selected').forEach(v => {
          v.classList.remove('selected')
        })
      }else{
        document.querySelector('.list-situation').classList.add('active')
        t.classList.add('active');
        const id = Array.from(t.classList).find(c => c.startsWith('s-'));
        const conf = s2tConf[id];
        for(let i = 0; i < conf.length; i++){
          document.querySelector(`.list-trouble li.${conf[i]}`).classList.add('suggest');
        }

        setTimeout(() => {
          gsap.to(window, {
            duration: 0.5,
            scrollTo: 'section.trouble',
            ease: 'power0.easeNone',
          })
        }, 100);
      }

      setTimeout(() => {
        rewriteURL();
      }, 100);
    });
  });

  document.querySelectorAll('.list-trouble li').forEach(t => {
    t.addEventListener('click', () => {
      const actived = t.classList.contains('active')
      document.querySelectorAll('.list-trouble li.active').forEach(s => {
        s.classList.remove('active')
      })

      if(actived){
        document.querySelector('.list-trouble').classList.remove('active')
        document.querySelectorAll('.list-trouble li.active, .list-content li.active, .list-group li.active').forEach(v => {
          v.classList.remove('active')
        })
        document.querySelectorAll('.list-content li.selected, .list-group li.selected').forEach(v => {
          v.classList.remove('selected')
        })
      }else{
        document.querySelector('.list-trouble').classList.add('active')
        t.classList.add('active');
        const id = Array.from(t.classList).find(c => c.startsWith('t-'));
        const conf = t2cgConf[id];
        for(let i = 0; i < conf.length; i++){
          if(conf[i].startsWith('c-')){
            document.querySelector(`.list-content li.${conf[i]}`).classList.add('active');
          }else if(conf[i].startsWith('g-')){
            document.querySelector(`.list-group li.${conf[i]}`).classList.add('active');
          }
        }

        setTimeout(() => {
          gsap.to(window, {
            duration: 0.5,
            scrollTo: {y: '.result-inner'},
            ease: 'power0.easeNone',
          })
        }, 100);
      }

      setContentsActivate();
      setTimeout(() => {
        rewriteURL();
      }, 100);
    });
  });

  document.querySelector('.btn_reset').addEventListener('click', () => {
    document.querySelector('.list-situation').classList.remove('active')
    document.querySelector('.list-trouble').classList.remove('active')
    document.querySelector('.list-reccomend').classList.remove('active')
    document.querySelector('.result-default').classList.add('active')
    document.querySelectorAll('.list-trouble li.suggest').forEach(v => {
      v.classList.remove('suggest')
    })
    document.querySelectorAll('.list-situation li.active, .list-trouble li.active, .list-content li.active, .list-group li.active, .list-reccomend li.active').forEach(v => {
      v.classList.remove('active')
    })
    document.querySelectorAll('.list-content li.selected, .list-group li.selected').forEach(v => {
      v.classList.remove('selected')
    })
    document.querySelector('.result-default').classList.add('active')

    window.history.replaceState('', '', location.pathname)

    setTimeout(() => {
      gsap.to(window, {
        duration: 0.5,
        scrollTo: {y: 0},
        ease: 'power0.easeNone',
      })
    }, 100);
  })
}

const setContentsActivate = () => {
  document.querySelectorAll(`.list-content li.active, .list-group li.active`).forEach(a => {
    a.classList.remove('active');
  });

  let confs = []
  document.querySelectorAll(`.list-trouble li.active`).forEach(a => {
    const id = Array.from(a.classList).find(c => c.startsWith('t-'));
    const conf = t2cgConf[id];
    confs = confs.concat(conf)
  });
  
  Array.from(new Set(confs)).forEach(c => {
    document.querySelector(`.result-list li.${c}`).classList.add('active');
  });
}

const clickCatalog = (isPC) => {
  const defaultRec = document.querySelector('.result-default');
  const targets = document.querySelectorAll('.list-content li, .list-group li');

  targets.forEach(t => {
    t.addEventListener('click', e => {
      e.stopPropagation()
      const id = getLiId(t, ['c', 'g']);
      const rec = document.querySelector(`.list-reccomend li.${id}`);

      const hd = hde => {
        const path = hde.composedPath()
        const recClose = path.find(p => {
          if(p.classList && p.classList.contains('close') && p.parentElement && p.parentElement.parentElement){
            return p.parentElement.parentElement.classList.contains('list-reccomend')
          }
        })

        if(recClose || (path[0].classList && path[0].classList.contains('list-reccomend'))) {
          document.querySelectorAll('.list-reccomend li .close').forEach(c => {
            c.parentElement.removeChild(c);
          });
          document.removeEventListener('click', hd);
          rec.parentElement.classList.remove('active')
          rec.classList.remove('active');
          t.classList.remove('selected');
        }

      }

      const selected = t.classList.contains('selected');

      rec.parentElement.classList.remove('active')
      document.querySelectorAll('.list-reccomend li .close').forEach(c => {
        c.parentElement.removeChild(c);
      });
      document.querySelectorAll('.list-reccomend li.active:not(.default)').forEach(r => {
        r.classList.remove('active')
      });
      document.querySelectorAll('.list-content li.selected, .list-group li.selected').forEach(cg => {
        cg.classList.remove('selected');
      });

      if(!selected){
        rec.parentElement.classList.add('active')
        rec.classList.add('active');
        t.classList.add('selected');

        rec.insertAdjacentHTML('beforeend', '<button class="close"></button>');
        document.addEventListener('click', hd);
      }

      if(!isPC){
        return
      }

      if(0 < document.querySelectorAll('.list-reccomend li.active').length){
        defaultRec.classList.remove('active')
      }else{
        defaultRec.classList.add('active')
      }
    });

  });
}

const clickHint = () => {
  const targets = document.querySelectorAll('.list-trouble .hint');
  targets.forEach(t => {
    const bal = t.parentElement.querySelector('.bal');
    t.addEventListener('click', e => {
      e.stopPropagation()
      const hd = (e) => {
        document.removeEventListener('click', hd);
        document.querySelectorAll('.list-trouble li .bal.active').forEach(b => {
          b.classList.remove('active')
        });
      }

      const actived = bal.classList.contains('active');
      document.querySelectorAll('.list-trouble li .bal.active').forEach(b => {
        b.classList.remove('active')
      });

      if(!actived){
        bal.classList.add('active');
        document.addEventListener('click', hd);
      }
    });
  });
}

const mouseoverHint = () => {
  const targets = document.querySelectorAll('.list-trouble .hint');
  targets.forEach(t => {
    const bal = t.parentElement.querySelector('.bal');
    t.addEventListener('mouseover', e => {
      bal.classList.add('active');
    });
    t.addEventListener('mouseleave', e => {
      bal.classList.remove('active');
    });
  });
}

const getLiId = (elm, prefixes) => {
  for(let i = 0; i < prefixes.length; i++){
    const result = Array.from(elm.classList).find(c => c.startsWith(`${prefixes[i]}-`))
    if(result !== void 0){
      return result
    }
  }

  return void 0
}

const manageStatus = () => {
  const searchState = getStatus()
  setStatus(searchState)
}

const getStatus = () => {
  const result = {
    s: void 0,
    t: void 0,
  }
  const raw = location.search.replace('?', '');
  if(!raw.includes('=')){
    return result
  }

  const units = raw.split('&').map(s => s.split('='))
  units.forEach(u => {
    if(u[0] === 's'){
      result.s = u[1]
    }else if(u[0] === 't'){
      result.t = u[1]
    }
  });

  return result
}

const setStatus = (state) => {
  if(state.s === void 0 && state.t === void 0){
    stated = true
    return
  }

  if(state.s !== void 0){
    document.querySelector(`.list-situation .s-0${state.s}`).click()
  }

  if(state.t !== void 0){
    document.querySelector(`.list-trouble .t-${('00' + Number(state.t)).slice(-2)}`).click()

    setContentsActivate();
  }
  stated = true
}

const rewriteURL = () => {
  if(stated){
    const situationsState = Array.from(document.querySelectorAll('.list-situation li.active')).map(li => getLiId(li, ['s']))
    const troublesState = Array.from(document.querySelectorAll('.list-trouble li.active')).map(li => getLiId(li, ['t']))

    const sb = []
    if(situationsState.length !== 0){
      sb.push(`s=${Number( situationsState[0].replace('s-', '') )}`)
    }
    if(troublesState.length !== 0){
      sb.push(`t=${Number( troublesState[0].replace('t-', '') )}`)
    }

    window.history.replaceState('', '', `?${sb.join('&')}`)
  }
}
